<template>
  <div class="bg-gray-50 rounded-lg p-4">
    <p class="text-sm text-gray-600 leading-relaxed">
      Mit dem Klick auf "Sicher bezahlen" bestätigen Sie, dass Sie unsere 
      <a href="https://mifokurse.de/agb" target="_blank" class="text-mifo-accent hover:underline font-medium">Allgemeinen Geschäftsbedingungen</a> 
      gelesen haben und mit deren Geltung einverstanden sind. Zudem haben Sie unsere 
      <a href="https://mifokurse.de/datenschutz" target="_blank" class="text-mifo-accent hover:underline font-medium">Datenschutzerklärung</a> 
      zur Kenntnis genommen.
    </p>
  </div>
</template>

<script>
export default {
  name: 'LegalNotice'
}
</script>

